import React, { Component } from 'react';
import config from 'config/api';
import DynamicForm from 'components/UI/DynamicForm';
class InvitationForm extends Component {
  constructor(props) {
    super(props);
    this._onFormComplete = this._onFormComplete.bind(this);
  }

  _getI18n() {
    this.i18n = {
      send: 'Enregistrer',
      sending: 'Enregistrement...',
    };
  }
  _onFormComplete() {
    const { onClose, onFormComplete } = this.props;
    if (onClose) onClose();
    else if (onFormComplete) onFormComplete();
  }
  render() {
    const { id } = this.props;
    const moduleConfig = {
      module: 'invitation',
      fetchUrl: config.baseUrl + '/api/invitation/edit',
      postUrl: config.baseUrl + '/api/invitation/edit',
      formTitle: this.props.id !== undefined ? 'Édition' : 'Création',
      redirectAfterEdit: false,
      afterEdit: 'onFormComplete',
      afterEditLog: '',
      afterEditHideForm: true,
    };
    return <DynamicForm moduleConfig={moduleConfig} id={id} onFormComplete={this._onFormComplete} {...this.props} />;
  }
}
/*
SerieForm.propTypes = {
};
*/

export default InvitationForm;



// WEBPACK FOOTER //
// ./src/components/UI/Invitation/InvitationForm.jsx